import Lottie from "lottie-react";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";

import successConfetti from "assets/loaders/success.json";

import "./SuccessCard.scss";

// ─── Success Card ─────────────────────────────────────────────────────────────

function SuccessCard({ onGoBack, onRequestAnother }: { onGoBack: () => void; onRequestAnother: () => void }) {
  return (
    <div className="rah-success-card">
      <div className="rah-success-card__body">
        <div className="rah-success-card__lottie-wrapper">
          <Lottie animationData={successConfetti} loop autoplay className="rah-success-card__lottie" />
        </div>
        <div className="rah-success-card__text">
          <h2 className="rah-success-card__title">Request received!</h2>
          <p className="rah-success-card__desc">
            Our team will review your requirements and hand-pick the right profiles for you. We&apos;ll be in touch
            soon.
          </p>
        </div>
      </div>
      <div className="rah-success-card__footer">
        <button type="button" className="rah-form-card__back-btn" onClick={onGoBack}>
          <ChevronLeftIcon sx={{ fontSize: 22 }} />
          Go back
        </button>
        <button type="button" className="rah-form-card__continue-btn" onClick={onRequestAnother}>
          Request another hire
        </button>
      </div>
    </div>
  );
}

export default SuccessCard;
